<template>
  <div class="box auth register">
    <h1 class="box__title">Register</h1>
    <p class="box__intro">Nice to have you here! We wish you a lot of fun using BackupMonkey. Any Questions regarding our service? Don't hesitate to contact us.</p>
    <div class="form" v-if="!registerSuccessful">
      <div class="form-group">
        <label for="email">{{ $t('auth.email')}}</label>
        <input type="email" class="input-big form-control" id="email" aria-describedby="emailHelp" v-model="email" required>
        <span class="help-block" v-if="error.email">{{emailMessage}}</span>
      </div>

      <div class="form-group">
        <label for="password">{{ $t('auth.password')}}</label>
        <input type="password" class="input-big form-control" id="password" aria-describedby="passwordHelp" v-model="password" required>
        <span class="help-block" v-if="error.password">{{passwordMessage}}</span>
      </div>

      <div class="form-group">
        <label for="password-confirm" class="control-label">{{ $t('auth.passwordconfirm')}}</label>
        <input class="input-big form-control" id="password-confirm" type="password" v-bind:placeholder="$t('auth.placeholderpassword')" v-model="passwordConfirmation" required>
        <span class="help-block" v-if="error.passwordConfirmation">{{passwordConfirmationMessage}}</span>
      </div>

      <div class="form-group">
        <label for="couponcode" class="control-label">{{ $t('auth.coupon')}}</label>
        <input class="input-big form-control" id="couponcode" type="text" v-bind:placeholder="$t('auth.placeholdercoupon')" v-model="coupon">
      </div>

      <div class="form-group">
        <div class="form-check">
          <input class="form-check-input" name="tos" type="checkbox" value="1" id="defaultCheck1" v-model="tos" required>
          <label class="form-check-label" for="defaultCheck1" v-html="$t('auth.tos')">
          </label>
        </div>
        <span class="help-block" v-if="error.tos">{{tosMessage}}</span>
      </div>

      <div>
        <div class="action d-flex justify-content-center">
          <button v-bind:disabled="!formValid" type="submit" class="btn btn--primary" @click="submitForm">
            {{ $t('auth.register')}}
          </button>
        </div>
      </div>
      <hr/>
      <div class="register__loginmessage">
        <p>{{ $t('auth.haveaccount')}}<br/>
          <router-link to="/login">{{ $t('auth.loginhere')}}</router-link>
        </p>
      </div>
    </div>

    <div class="message" v-if="registerSuccessful">
      <h2 style="text-align: center">{{ $t('auth.registrationsuccessfull')}}</h2>

      <div style="text-align: center" class="success-msg">
        <p>{{ $t('auth.registrationemail')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import mixins from '../mixins'

export default {
  name: 'Register',

  mixins: [mixins],

  computed: {
    formValid () {
      return this.email !== '' &&
        this.password !== '' &&
        this.passwordConfirmation !== '' &&
        this.password === this.passwordConfirmation &&
        this.tos === true
    }

  },

  data () {
    return {
      email: '',
      password: '',
      passwordConfirmation: '',
      coupon: '',
      tos: '',
      error: {
        email: false,
        emailMessage: '',
        password: false,
        passwordMessage: '',
        passwordConfirmation: false,
        passwordConfirmationMessage: '',
        tos: false,
        tosMessage: ''
      },
      registerSuccessful: false
    }
  },

  methods: {
    ...mapActions('user', ['register']),

    submitForm () {
      if (this.formValid) {
        const payload = {
          email: this.email,
          password: this.password,
          password_confirmation: this.passwordConfirmation,
          coupon: this.coupon,
          tos: this.tos
        }

        this.register(payload).then(() => {
          this.registerSuccessful = true
        })
      }
    }
  }
}
</script>
